package com.partejar.app.core.session

import com.russhwolf.settings.Settings

interface CurrentWorkspaceRepository {
    fun currentWorkspaceId(): Long?
    fun selectWorkspace(workspaceId: Long)
    fun clear()
}

class SettingsCurrentWorkspaceRepository(
    private val settings: Settings
) : CurrentWorkspaceRepository {

    override fun currentWorkspaceId(): Long? {
        return settings.getStringOrNull(CURRENT_WORKSPACE_KEY)?.toLongOrNull()
    }

    override fun selectWorkspace(workspaceId: Long) {
        require(workspaceId > 0) { "Workspace id must be positive" }
        settings.putString(CURRENT_WORKSPACE_KEY, workspaceId.toString())
    }

    override fun clear() {
        settings.remove(CURRENT_WORKSPACE_KEY)
    }

    private companion object {
        const val CURRENT_WORKSPACE_KEY = "session.current_workspace_id"
    }
}
